import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PoButtonModule } from '@po-ui/ng-components';

@Component({
  selector: 'app-filter-button',
  imports: [PoButtonModule],
  templateUrl: './filter-button.component.html',
  styleUrl: './filter-button.component.css'
})
export class FilterButtonComponent {
  @Input() seeFilter!: boolean;
  @Output() onClick = new EventEmitter();
  funnelIcon = 'an an-funnel-simple';
  funnelIconFill = 'an an-arrow-down';
}
